import { render, staticRenderFns } from "./ProductComponentOptional.vue?vue&type=template&id=80d8f682&"
import script from "./ProductComponentOptional.vue?vue&type=script&lang=ts&"
export * from "./ProductComponentOptional.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports